import React, {useState} from 'react';
import {connect} from 'react-redux';
import AddZoneMap from "./AddZoneMap/AddZoneMap";
import './AddZone.css';
import AddZoneHeader from "./AddZoneHeader/AddZoneHeader";
import {addZone} from "../../store/notificationsSlice";
import {useHistory} from "react-router";

const AddZone = (props) => {
	const history = useHistory();

	const [center, setCenter] = useState(null); // [42.123, -83.123]
	const [radius, setRadius] = useState(0.5); // In km

	const saveZone = name => {
		props.addZone(name, center[0], center[1], radius);
		history.push("/");
	};

	return (
		<div className='AddZoneContainer'>
			<AddZoneHeader center={center} radius={radius}  saveZone={saveZone} />
			<AddZoneMap className='AddZoneMap'
						center={center}	setCenter={setCenter}
						radius={radius} setRadius={setRadius}
						loadingElement={<div style={{ height: "100%", width:"100%" }} />}
						containerElement={<div style={{ height: "100%", width:"100%" }} />}
						mapElement={<div style={{ height: "100%", width:"100%" }} />}
			/>
		</div>
	);
};

// const mapStateToProps = (state) => {
// 	return {
// 		NAME: state.NAME
	// };
// };

const mapDispatchToProps = (dispatch) => {
	return {
		addZone: (name, latitude, longitude, radius) => dispatch(addZone(name, latitude, longitude, radius))
	};
};

export default connect(null, mapDispatchToProps)(AddZone);